package org.hs_soft.runmynesto.domain.usecase.login

import org.hs_soft.runmynesto.domain.repository.network_datasource.login.SendCodeForResetPassRepository


class SendCodeForRestPassUseCase(
    private val repository: SendCodeForResetPassRepository
) {
    suspend operator fun invoke(
        email:String,
        onSuccess:()->Unit,
        onError:(String)->Unit,
    ) {
        repository.sendResetCodeToEmail(
            email =email ,
            onSuccess = {
                onSuccess()
            },
            onError={
                onError(it)
            }

        )
    }
}